module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/asterisk_bullet.31a167d9.svg";